module.exports = __webpack_public_path__ + "static/media/password-removal.a30054e1.jpg";